import template from './invoiceAddLineItemModal.html';
import controller from './invoiceAddLineItemModal.controller';

let invoiceAddLineItemModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: 'invoice-modal-popup hmodal-info animated zoomIn'
};

export default invoiceAddLineItemModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/InvoiceAddLineItemModal/invoiceAddLineItemModal.component.js